import { render, staticRenderFns } from "./BranchHomeIntro.vue?vue&type=template&id=53ee265b&scoped=true"
import script from "./BranchHomeIntro.vue?vue&type=script&lang=js"
export * from "./BranchHomeIntro.vue?vue&type=script&lang=js"
import style0 from "./BranchHomeIntro.vue?vue&type=style&index=0&id=53ee265b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ee265b",
  null
  
)

export default component.exports